import {isPremiumUser} from "./user";

export function updateExclusivePremiumProduct(container)
{
    let isPremium = isPremiumUser();

    if (!container.classList.contains('exclusive-premium') || isPremium) return;

    container.querySelector('.add-to-cart').classList.add('d-none');
    container.querySelector('.premium-subscribe').classList.remove('d-none');
}

export function showImageSliderLoader()
{
    let imageSlider = document.querySelector('#product-page .image-slider');
    if (!imageSlider) return;

    let loader = imageSlider.parentElement.querySelector('.loader');
    if (!loader || !loader.classList.contains('d-none')) return;

    loader.classList.remove('d-none');
}

export function hideImageSliderLoader()
{
    let imageSlider = document.querySelector('#product-page .image-slider');
    if (!imageSlider) return;

    let loader = imageSlider.parentElement.querySelector('.loader');
    if (!loader || loader.classList.contains('d-none')) return;

    loader.classList.add('d-none');
}
